/**
 * Input Component
 * A reusable input component with default props
 */
'use client'

import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string
  name: string
  type?: string
  autoComplete?: string
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder: string
  className?: string
  error?: boolean
}

export default function Input ({
  id,
  name,
  type = 'text',
  autoComplete = 'off',
  value = '',
  onChange = () => {},
  placeholder,
  className = '',
  error = false,
  ...props
}: InputProps): React.JSX.Element {
  return (
    <input
      id={id}
      name={name}
      type={type}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
      className={`
        mt-1 p-3.5 appearance-none relative block w-full font-medium text-sm border border-solid rounded-lg text-neutrals-900 
        placeholder-neutrals-500 bg-white focus:outline-none focus:ring-0
        ${error ? 'border-error focus:border-error' : 'border-neutrals-400 focus:border-primary-800'}
        ${className}
      `}
      placeholder={placeholder}
      {...props}
    />
  )
}
